//          ___     __
//    _____/ (_)___/ /__  _____
//   / ___/ / / __  / _ \/ ___/
//  (__  ) / / /_/ /  __/ /
// /____/_/_/\__,_/\___/_/

/* global */

import { updateTeamFooter } from './team';
import 'slick-carousel/slick/slick.min.js';
import { app } from './app';

const setupSlider = parent => {
  console.log('{ setupSlider }');
  // console.log( 'parent: %o', parent );

  const slickOptions = {
    easing: 'easeInOutQuart',
    // infinite: true,
    slidesToShow: 1,
    // dots: false,
    speed: 1000,
    // autoplay: false,
    autoplaySpeed: 4000,
    nextArrow:
      '<button type="button" class="slider-controls__link slider-controls__left"><svg class="slider__arrow" width="100%" viewBox="0 0 16 28" xmlns="http://www.w3.org/2000/svg"><path d="M3 0L0 3l10 11L0 25l3 3 13-14L3 0z"/></svg></button>',
    prevArrow:
      '<button type="button" class="slider-controls__link slider-controls__right"><svg class="slider__arrow" width="100%" viewBox="0 0 16 28" xmlns="http://www.w3.org/2000/svg"><path d="M3 0L0 3l10 11L0 25l3 3 13-14L3 0z"/></svg></button>'
  };

  if ($('.barba-container').hasClass('desktop')) {
    slickOptions.nextArrow =
      '<button type="button" class="slider-controls__link slider-controls__left js-slide-link"></button>';
    slickOptions.prevArrow =
      '<button type="button" class="slider-controls__link slider-controls__right js-slide-link"></button>';
  }

  // ----------------------------------------------------------------------------
  // Team Slider
  // ----------------------------------------------------------------------------
  if ('slider-team' === $(parent).attr('id')) {
    slickOptions.autoplay = false;
  }

  // console.log( 'slickOptions: %o', slickOptions );
  // console.log( '$( parent ).slick: %o', $( parent ).slick );
  // console.log( 'typeof $( parent ).slick( "getSlick" ): %o', typeof $( parent ).slick( 'getSlick' ) );

  // init Slick
  $(parent).slick(slickOptions);

  // ----------------------------------------------------------------------------
  //
  // Before slide change event
  //
  // ----------------------------------------------------------------------------
  $(parent).on('beforeChange', function (ev, slick, currentSlide) {
    // console.log( 'ev: %o', ev );
    // console.log( 'slick: %o', slick );
    // console.log( 'currentSlide: %o', currentSlide );

    let slide = $(parent).find(
      '.slick-slide[data-slick-index=' + currentSlide + ']'
    );

    // ----------------------------------------------------------------------------
    // Video slides
    // ----------------------------------------------------------------------------
    if (slide.hasClass('slider__slide--video')) {
      // console.log( 'Video slide about to leave' );
      const videoID = $(slide).find('iframe').attr('id');
      // console.log( 'videoID: %o', videoID );
      // console.log( 'app.youtubePlayers[ videoID ]: %o', app.youtubePlayers[ videoID ] );
      app.youtubePlayers[videoID].pauseVideo();
    }

    // ----------------------------------------------------------------------------
    // Team Slider
    // ----------------------------------------------------------------------------
    if ('slider-team' === $(parent).attr('id')) {
      // hide footer text
      $('.team-footer__content .splitting').removeClass('show');
    }
  });

  // ----------------------------------------------------------------------------
  //
  // After slide change event
  //
  // (ev, slick, currentSlide)
  // ----------------------------------------------------------------------------
  $(parent).on('afterChange', function () {
    // ----------------------------------------------------------------------------
    // Team Slider
    // ----------------------------------------------------------------------------
    if ('slider-team' === $(parent).attr('id')) {
      // update team footer text
      updateTeamFooter();
    }

    // console.log( 'ev: %o', ev );
    // console.log( 'slick: %o', slick );
    // console.log( 'currentSlide: %o', currentSlide );

    // let slide = $( parent ).find( '.slick-slide[data-slick-index=' + currentSlide + ']' );

    // if( slide.hasClass('slider__slide--video') ){

    // console.log( 'Video slide now showing' );
    // const videoID = $(slide).find('iframe').attr('id');
    // console.log( 'videoID: %o', videoID );
    // console.log( 'app.youtubePlayers[ videoID ]: %o', app.youtubePlayers[ videoID ] );
    // app.youtubePlayers[ videoID ].playVideo();

    // }
  });
};

export { setupSlider };



// WEBPACK FOOTER //
// ./scripts/modules/slider.js